import { BodyRegularBold, CaptionRegular } from '@components/atoms/typography';

const UNLIMITED_GLYPH = '∞';

type FreeTransfersPillProps = {
  freeTransfers: number;
  remainingTransfers?: number;
  isUnlimited?: boolean;
};

const detailCopyFor = (isUnlimited: boolean, effective: number): string => {
  if (isUnlimited) return 'Unlimited this gameweek';
  if (effective === 0) return 'Banked transfers spent';
  if (effective === 1) return 'Use it wisely';
  return 'Banked for the upcoming gameweek';
};

export const FreeTransfersPill = ({
  freeTransfers,
  remainingTransfers,
  isUnlimited = false
}: FreeTransfersPillProps) => {
  const effective = remainingTransfers ?? freeTransfers;
  const display = isUnlimited ? UNLIMITED_GLYPH : effective.toString();
  const detailCopy = detailCopyFor(isUnlimited, effective);

  return (
    <div
      className="flex items-center justify-between gap-4 rounded-xl bg-primary-50/60 px-4 py-3"
      data-cy="free-transfers-pill"
    >
      <div className="flex flex-col">
        <BodyRegularBold className="mb-0 text-neutral-800">
          Free transfers
        </BodyRegularBold>
        <CaptionRegular className="mb-0 mt-0.5 text-neutral-500">
          {detailCopy}
        </CaptionRegular>
      </div>
      <span
        className="font-sans text-3xl font-extrabold tabular-nums leading-none text-primary-600"
        data-cy="free-transfers-count"
      >
        {display}
      </span>
    </div>
  );
};
